const editableConfiguration = value => ({
  ...(typeof value?.maxChoices === 'number' ? { maxChoices: value.maxChoices } : {}),
  ...(typeof value?.retention === 'boolean' ? { retention: value.retention } : {}),
  ...(value?.rankedChoice
    ? {
      rankedChoice: {
        enabled: value.rankedChoice.enabled ?? false,
        maxChoices: value.rankedChoice.maxChoices ?? 1
      }
    }
    : {})
});

const configurationForPatch = value => {
  const configuration = editableConfiguration(value);
  return Object.keys(configuration).length > 0 ? configuration : null;
};

export {
  editableConfiguration,
  configurationForPatch
};
